import { render, staticRenderFns } from "./VehicleScoringComponent.vue?vue&type=template&id=1f4d5d0d"
import script from "./VehicleScoringComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleScoringComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports